import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import {
  SUPERSET_TOTAL_CSAT_INVITES_SENT,
  SUPERSET_TOTAL_CSAT_INVITES_SENT_ERROR,
  SUPERSET_TOTAL_CSAT_INVITES_SENT_SUCCESS,
} from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetTotalCSATInvitesSent({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_TOTAL_CSAT_INVITES_SENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_TOTAL_CSAT_INVITES_SENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_TOTAL_CSAT_INVITES_SENT_ERROR, payload: error });
  }
}

export function* watchSupersetTotalCSATInvitesSent() {
  yield takeEvery(SUPERSET_TOTAL_CSAT_INVITES_SENT, supersetTotalCSATInvitesSent);
}

function* supersetTotalCSATInvitesSentSaga() {
  yield all([fork(watchSupersetTotalCSATInvitesSent)]);
}

export default supersetTotalCSATInvitesSentSaga;
